<template>
  <div></div>
</template>

<script>
const utils = require("@/libs/utils");
export default {
  data() {
    return {};
  },
  created() {
    if (window.injectProperty && window.injectProperty.prerender) {
      return;
    }
    function getURLParameter(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.search
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    }
    const channelConfigs = {
      pax: "1e10444e-e8ea-45fb-9473-375ace6e3c42",
      besta: "1e10444e-e8ea-45fb-9473-375ace6e3c42",
      metod: "1e10444e-34we-4532-4444-375ajkfienw2",
      kitchen: "1e10444e-34we-4532-4444-375ajkfienw2",
      billy: "1e10444e-e8ea-45fb-9473-375ace6e3c42",
      default: "412d73a9-ab11-42e5-b845-76a55141bd91",
      smp: "23e8419b-2044-4904-81a8-0e3fdd0037ad"
    };
    const pages = {
      "1e10444e-e8ea-45fb-9473-375ace6e3c42": "PIP_Popup_Pax", //"PIP_Popup_Besta", "PIP_Popup_Billy"
      "1e10444e-34we-4532-4444-375ajkfienw2": "PIP_Popup_Kitchen",
      "412d73a9-ab11-42e5-b845-76a55141bd91": "mypage",
      "23e8419b-2044-4904-81a8-0e3fdd0037ad": "mypage"
    }
    let platform = utils.getClientPlatform()
    let channel = getURLParameter("channel");
    const defaultConfigId = platform == "WechatMiniprogram" ? channelConfigs.smp : channelConfigs.default
    const configId = getURLParameter("configId") || channelConfigs[channel] ||  defaultConfigId
    let page = pages[configId]
    const scenario = getURLParameter("scenario")
    if (scenario == 'IB_Checkout') {
      page = "IB"
    }

    let text = getURLParameter("autoText");

    // if (process.env.APP_SCHEME === 'ikeaqa') {
      let domain = process.env.APP_SCHEME === 'ikeaqa' ? 'https://cnos-ppe-im.ingka-dt.cn' : 'https://kefu.csc.ikea.cn'
      const searchDomainList = ['baidu.com', 'bing.com', 'google', 'sogou.com', 'so.com', 'sm.cn', 'yahoo.com', 'yandex.com', '360.cn', 'quark.cn', 'moonshot.cn']
      const referer = document.referrer
      const useProd = searchDomainList.some(domain => referer.includes(domain))
      if (useProd) {
          domain = 'https://kefu.csc.ikea.cn'
      }
      // let query = location.search ?
      //   (location.search.includes('configId') ? location.search : location.search + `&configId=${configId}`)
      //   : `?configId=${configId}`;
      let query = location.search
      if (query && page || query.includes('page=')) {
        query = query.includes('page=') ? query : query + `&page=${page}`
        query.replace(`&configId=$configId`, '')
      } else if (!query && page) {
        query = `?page=${page}`
      } else if (query) {
        query = query.includes('configId') ? query : query + `&configId=${configId}`
      } else {
        query = `?configId=${configId}`
      }

      console.log(query)

      // 兼容app取不到cookie的问题
      // let token = utils.getTokenSync()
      // query += (!query.includes('token=') && token) ? `&token=${token.replace("Bearer ", "")}` : ''

      query += (!query.includes('platform=') && platform) ? `&platform=${platform}` : ''
      
      // 增加时间戳，清除客户端缓存，后面可以删掉
      query += `&t=HdBdsyu9op1`

      window.location.replace(`${domain}/webim/im.html${query}`);

      return;
    // }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/app/CustomerService.vue